/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Art_Value_DueInputs */

const en_svc_integration_art_value_due = /** @type {(inputs: Svc_Integration_Art_Value_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs review`)
};

const lv_svc_integration_art_value_due = /** @type {(inputs: Svc_Integration_Art_Value_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jāpārbauda`)
};

/**
* | output |
* | --- |
* | "Needs review" |
*
* @param {Svc_Integration_Art_Value_DueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_art_value_due = /** @type {((inputs?: Svc_Integration_Art_Value_DueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Art_Value_DueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_art_value_due(inputs)
	return en_svc_integration_art_value_due(inputs)
});